/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetDogmaEffectsEffectIdModifier } from './GetDogmaEffectsEffectIdModifier';
import {
    GetDogmaEffectsEffectIdModifierFromJSON,
    GetDogmaEffectsEffectIdModifierFromJSONTyped,
    GetDogmaEffectsEffectIdModifierToJSON,
    GetDogmaEffectsEffectIdModifierToJSONTyped,
} from './GetDogmaEffectsEffectIdModifier';

/**
 * 200 ok object
 * @export
 * @interface GetDogmaEffectsEffectIdOk
 */
export interface GetDogmaEffectsEffectIdOk {
    /**
     * description string
     * @type {string}
     * @memberof GetDogmaEffectsEffectIdOk
     */
    description?: string;
    /**
     * disallow_auto_repeat boolean
     * @type {boolean}
     * @memberof GetDogmaEffectsEffectIdOk
     */
    disallowAutoRepeat?: boolean;
    /**
     * discharge_attribute_id integer
     * @type {number}
     * @memberof GetDogmaEffectsEffectIdOk
     */
    dischargeAttributeId?: number;
    /**
     * display_name string
     * @type {string}
     * @memberof GetDogmaEffectsEffectIdOk
     */
    displayName?: string;
    /**
     * duration_attribute_id integer
     * @type {number}
     * @memberof GetDogmaEffectsEffectIdOk
     */
    durationAttributeId?: number;
    /**
     * effect_category integer
     * @type {number}
     * @memberof GetDogmaEffectsEffectIdOk
     */
    effectCategory?: number;
    /**
     * effect_id integer
     * @type {number}
     * @memberof GetDogmaEffectsEffectIdOk
     */
    effectId: number;
    /**
     * electronic_chance boolean
     * @type {boolean}
     * @memberof GetDogmaEffectsEffectIdOk
     */
    electronicChance?: boolean;
    /**
     * falloff_attribute_id integer
     * @type {number}
     * @memberof GetDogmaEffectsEffectIdOk
     */
    falloffAttributeId?: number;
    /**
     * icon_id integer
     * @type {number}
     * @memberof GetDogmaEffectsEffectIdOk
     */
    iconId?: number;
    /**
     * is_assistance boolean
     * @type {boolean}
     * @memberof GetDogmaEffectsEffectIdOk
     */
    isAssistance?: boolean;
    /**
     * is_offensive boolean
     * @type {boolean}
     * @memberof GetDogmaEffectsEffectIdOk
     */
    isOffensive?: boolean;
    /**
     * is_warp_safe boolean
     * @type {boolean}
     * @memberof GetDogmaEffectsEffectIdOk
     */
    isWarpSafe?: boolean;
    /**
     * modifiers array
     * @type {Array<GetDogmaEffectsEffectIdModifier>}
     * @memberof GetDogmaEffectsEffectIdOk
     */
    modifiers?: Array<GetDogmaEffectsEffectIdModifier>;
    /**
     * name string
     * @type {string}
     * @memberof GetDogmaEffectsEffectIdOk
     */
    name?: string;
    /**
     * post_expression integer
     * @type {number}
     * @memberof GetDogmaEffectsEffectIdOk
     */
    postExpression?: number;
    /**
     * pre_expression integer
     * @type {number}
     * @memberof GetDogmaEffectsEffectIdOk
     */
    preExpression?: number;
    /**
     * published boolean
     * @type {boolean}
     * @memberof GetDogmaEffectsEffectIdOk
     */
    published?: boolean;
    /**
     * range_attribute_id integer
     * @type {number}
     * @memberof GetDogmaEffectsEffectIdOk
     */
    rangeAttributeId?: number;
    /**
     * range_chance boolean
     * @type {boolean}
     * @memberof GetDogmaEffectsEffectIdOk
     */
    rangeChance?: boolean;
    /**
     * tracking_speed_attribute_id integer
     * @type {number}
     * @memberof GetDogmaEffectsEffectIdOk
     */
    trackingSpeedAttributeId?: number;
}

/**
 * Check if a given object implements the GetDogmaEffectsEffectIdOk interface.
 */
export function instanceOfGetDogmaEffectsEffectIdOk(value: object): value is GetDogmaEffectsEffectIdOk {
    if (!('effectId' in value) || value['effectId'] === undefined) return false;
    return true;
}

export function GetDogmaEffectsEffectIdOkFromJSON(json: any): GetDogmaEffectsEffectIdOk {
    return GetDogmaEffectsEffectIdOkFromJSONTyped(json, false);
}

export function GetDogmaEffectsEffectIdOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDogmaEffectsEffectIdOk {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'disallowAutoRepeat': json['disallow_auto_repeat'] == null ? undefined : json['disallow_auto_repeat'],
        'dischargeAttributeId': json['discharge_attribute_id'] == null ? undefined : json['discharge_attribute_id'],
        'displayName': json['display_name'] == null ? undefined : json['display_name'],
        'durationAttributeId': json['duration_attribute_id'] == null ? undefined : json['duration_attribute_id'],
        'effectCategory': json['effect_category'] == null ? undefined : json['effect_category'],
        'effectId': json['effect_id'],
        'electronicChance': json['electronic_chance'] == null ? undefined : json['electronic_chance'],
        'falloffAttributeId': json['falloff_attribute_id'] == null ? undefined : json['falloff_attribute_id'],
        'iconId': json['icon_id'] == null ? undefined : json['icon_id'],
        'isAssistance': json['is_assistance'] == null ? undefined : json['is_assistance'],
        'isOffensive': json['is_offensive'] == null ? undefined : json['is_offensive'],
        'isWarpSafe': json['is_warp_safe'] == null ? undefined : json['is_warp_safe'],
        'modifiers': json['modifiers'] == null ? undefined : ((json['modifiers'] as Array<any>).map(GetDogmaEffectsEffectIdModifierFromJSON)),
        'name': json['name'] == null ? undefined : json['name'],
        'postExpression': json['post_expression'] == null ? undefined : json['post_expression'],
        'preExpression': json['pre_expression'] == null ? undefined : json['pre_expression'],
        'published': json['published'] == null ? undefined : json['published'],
        'rangeAttributeId': json['range_attribute_id'] == null ? undefined : json['range_attribute_id'],
        'rangeChance': json['range_chance'] == null ? undefined : json['range_chance'],
        'trackingSpeedAttributeId': json['tracking_speed_attribute_id'] == null ? undefined : json['tracking_speed_attribute_id'],
    };
}

export function GetDogmaEffectsEffectIdOkToJSON(json: any): GetDogmaEffectsEffectIdOk {
    return GetDogmaEffectsEffectIdOkToJSONTyped(json, false);
}

export function GetDogmaEffectsEffectIdOkToJSONTyped(value?: GetDogmaEffectsEffectIdOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'disallow_auto_repeat': value['disallowAutoRepeat'],
        'discharge_attribute_id': value['dischargeAttributeId'],
        'display_name': value['displayName'],
        'duration_attribute_id': value['durationAttributeId'],
        'effect_category': value['effectCategory'],
        'effect_id': value['effectId'],
        'electronic_chance': value['electronicChance'],
        'falloff_attribute_id': value['falloffAttributeId'],
        'icon_id': value['iconId'],
        'is_assistance': value['isAssistance'],
        'is_offensive': value['isOffensive'],
        'is_warp_safe': value['isWarpSafe'],
        'modifiers': value['modifiers'] == null ? undefined : ((value['modifiers'] as Array<any>).map(GetDogmaEffectsEffectIdModifierToJSON)),
        'name': value['name'],
        'post_expression': value['postExpression'],
        'pre_expression': value['preExpression'],
        'published': value['published'],
        'range_attribute_id': value['rangeAttributeId'],
        'range_chance': value['rangeChance'],
        'tracking_speed_attribute_id': value['trackingSpeedAttributeId'],
    };
}

